import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Collapse } from '@material-ui/core';

const NotificationListComponent = props => {
  const { notifications, clickNotification } = props;

  const [openItemId, setOpenItemId] = useState(0);

  function handleItemClick(id) {
    clickNotification(id);
    if (id === openItemId) {
      setOpenItemId(0);
    } else {
      setOpenItemId(id);
    }
  }

  return (
    <>
      {notifications.map(item => {
        return (
          <>
            <Button
              className={item.seen ? 'header' : 'header_white'}
              onClick={() => handleItemClick(item.id)}
              aria-controls="example-collapse-text"
              aria-expanded={openItemId === item.id}
            >
              {item.title}
            </Button>
            <Collapse in={openItemId === item.id}>
              <div className={'description'}>{item.description}</div>
            </Collapse>
          </>
        );
      })}
    </>
  );
};

export default NotificationListComponent;
